import MenuList from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ManageMenu from "../../../../../components/sections/admin/Menu/ManageMenu";

export const menuRoutes = () => [
  {
    path: "/admin/menu",
    component: () => (
      <TabsNavigation title="Menu Management" tabRoutes={[]}>
        <MenuList />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Menu Management",
  },
  // {
  //   path: "/admin/menu-categories",
  //   component: () => (
  //     <TabsNavigation title="Menu Categories" tabRoutes={[]}>
  //       <MenuCategory />
  //     </TabsNavigation>
  //   ),
  //   layout: "admin",
  //   routeType: "admin",
  //   title: "Posts Management",
  // },
  {
    path: "/admin/manage-menu",
    component: ManageMenu,
    layout: "admin",
    routeType: "admin",
    title: "Manage Menu",
  },
  {
    path: `/admin/manage-menu/:id`,
    component: ManageMenu,
    layout: "admin",
    routeType: "admin",
    title: "Manage Menu",
  },
];
